import moment from 'moment';

export const formatDate = (date?: string, inputFormat = 'YYYY-MM-DD', outputFormat = 'DD-MM-YYYY') => {
  if (date) {
    return moment(date, inputFormat).format(outputFormat);
  }

  return '';
};
